class ProductCard extends HTMLElement {
    constructor() {
        super();

        this.searchForColors = this.searchForColors.bind(this);
    }

    connectedCallback() {
        // Attributes
        this.collectionColorTag = this.getAttribute("data-collection-color-tag") || undefined;
        this.colorsSelector = this.getAttribute("data-colors-selector") || "";

        // Attributes validation
        if (!this.collectionColorTag) return;
        if (!this.colorsSelector) return;
        
        // Elements
        this.colorsEl = this.querySelector(this.colorsSelector);

        // Elements validation
        if (!this.colorsEl) return;

        // Events
        this.addEventListener("mouseover", this.searchForColors);
    }

    async searchForColors() {
        if (!this.colorsEl.innerHTML) {
            // Search by tag
            const url = `/search?resources[type]=product&section_id=product-card-colors&t=${Date.now()}&q="${this.collectionColorTag}"`;

            try {
                // Fetch search page
                const response = await fetch(url, { cache: "force-cache" });
                const responseText = await response.text();

                // Display number of colors in product-card
                this.colorsEl.innerHTML = responseText;
            } catch (error) {
                console.error('[ProductCard]', error.message);
            }
        }
    }
}

if (customElements.get("w3-product-card") === undefined) {
    customElements.define("w3-product-card", ProductCard);
}
